<div class="flex flex-col sm:flex-row w-full justify-between items-start sm:items-center mb-8">
  <h1 class="font-bold mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-full">{{ { key: 'companion' } | i18n }}</h1>
  <div class="mt-4 sm:mt-0 flex-shrink-0">
    <button
      class="items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
      (click)="addCompanion()"
    >
      {{ { key: 'enterNewAccompanyingPerson' } | i18n }}
    </button>
  </div>
</div>

<div class="flex flex-col">
  @if (companions.isLoading()) {
    <div class="flex justify-center items-center h-64">
      <app-loading [noWhitespace]="true"></app-loading>
    </div>
  } @else if (companions.error()) {
    <div class="flex justify-center items-center h-64">
      <div class="text-red-500">{{ { key: 'errorLoading' } | i18n }}</div>
    </div>
  } @else {
    <div class="flex flex-row w-full justify-end mb-4"></div>
    <div class="flex flex-col gap-4">
      @for (companion of companions.value(); track companion._id) {
        <div class="flex flex-col hover:bg-opacity-10 hover:bg-primary-600 p-4 border border-primary-600">
          <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between overflow-hidden">
            <div class="overflow-hidden whitespace-nowrap text-ellipsis w-full">
              <strong>{{ companion.displayValue }}</strong>
            </div>
            <div class="mt-4 sm:mt-0">
              <button
                class="items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
                (click)="editCompanion(companion._id)"
              >
                {{ { key: 'edit' } | i18n }}
              </button>
            </div>
          </div>

          <!-- @if (isCancellationPossible(booking)) {
        <button
          class="inline-flex justify-center  border border-transparent bg-primary-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-700 focus:ring-offset-2"
          (click)="openCancellationOverlay(booking)"
        >
          Stornieren
        </button>
      } @else {
        <div class="text-gray-700">Stornierung nicht mehr möglich</div>
      } -->
        </div>
      } @empty {
        <div class="flex justify-center items-center h-64">
          <div class="text-gray-500">{{ { key: 'noAccompanyingPersonsRecorded' } | i18n }}</div>
        </div>
      }
    </div>
  }
</div>
